<div class="counties-wrap">
  <div class="auth-select">
    <p class="ck">Original single-letter authorities · select a letter</p>
    <div class="auth-letters" role="listbox" aria-label="Historic issuing authorities, A to Z">
      <div class="al"
           *ngFor="let rec of records; let i = index; trackBy: trackByLetter"
           role="option"
           [attr.aria-selected]="isSelected(rec)"
           [attr.aria-label]="rec.letter + ': ' + rec.authorityName"
           [class.sel]="isSelected(rec)"
           [attr.tabindex]="isSelected(rec) ? 0 : -1"
           (click)="select(rec)"
           (keydown)="onKeydown($event, i)">
        <span class="plate-bs"><span class="ch">{{rec.letter}}</span></span>
      </div>
    </div>
    <p class="auth-note">The original single-letter codes. In England and Wales they were allocated in 1903 by 1901-census population, so the busiest places took the earliest letters; Scotland (G, S, V) and Ireland (Z) were allocated separately. The date shown is when each authority exhausted its combinations. Source: DVLA / CVPG records.</p>
  </div>

  <div class="auth-panel" aria-live="polite">
    <div class="auth-info">
      <!-- never issued -->
      <ng-container *ngIf="selected.state === 'never'; else issuedInfo">
        <div class="ah">
          <span class="plate-bs"><span class="ch">{{selected.letter}}</span></span>
          <div><div class="an">Never issued</div><div class="ar">not a single-letter area code</div></div>
        </div>
        <div class="auth-metric"><span class="k">Status</span><span class="v">{{selected.note}}</span></div>
        <p class="auth-tag">Archive entry · DVLA / CVPG records</p>
      </ng-container>
      <ng-template #issuedInfo>
        <div class="ah">
          <span class="plate-bs"><span class="ch">{{selected.letter}}</span></span>
          <div>
            <div class="an">{{selected.authorityName}}</div>
            <div class="ar">{{selected.region}}<ng-container *ngIf="selected.populationRank"> · {{selected.populationRank}}</ng-container></div>
          </div>
        </div>
        <div class="auth-metric"><span class="k">Period of issue</span><span class="v"><b>{{period(selected)}}</b></span></div>
        <div class="auth-metric" *ngIf="selected.notableMark">
          <span class="k">Notable mark</span>
          <span class="v"><span class="plate-bs sm"><span class="ch">{{selected.notableMark}}</span></span></span>
        </div>
        <div class="auth-metric" *ngIf="selected.reversedFrom1953">
          <span class="k">Reversed marks</span>
          <span class="v rev">1953 to 1962, e.g. 1000 {{selected.letter}}</span>
        </div>
        <div class="auth-metric" *ngIf="selected.note">
          <span class="k">Historical note</span><span class="v">{{selected.note}}</span>
        </div>
        <p class="auth-tag">Archive entry · DVLA / CVPG records · photograph credited where shown</p>
      </ng-template>
    </div>

    <div class="auth-media">
      <!-- ready: archive frame + caption + credit (photo binary pends S3) -->
      <figure class="am-photo" *ngIf="selected.state === 'ready'">
        <!-- the photograph itself when the production asset exists (licensed
             CC/PD originals); the archive frame while rights clearance or
             upload is still pending -->
        <img class="amp-img"
             *ngIf="selected.imageAsset"
             [src]="selected.imageAsset"
             [alt]="selected.caption"
             loading="lazy"/>
        <div class="amp-frame" *ngIf="!selected.imageAsset">
          <span class="plate-bs"><span class="ch">{{selected.registration}}</span></span>
          <span class="amp-tag">Photograph pending rights clearance</span>
        </div>
        <figcaption class="am-cap">{{selected.caption}}</figcaption>
        <p class="am-cred">
          <a [href]="selected.sourceUrl" target="_blank" rel="noopener">{{creditLine(selected)}}</a>
        </p>
      </figure>

      <!-- gap: black card, line-art, contribute -->
      <div class="am-gap" *ngIf="selected.state === 'gap'">
        <!-- veteran car, c.1903: upright radiator, stubby bonnet, two seat backs
             above an open tonneau, tall equal wire wheels. Drawn short and tall
             so the wheels carry the silhouette at the size this renders. -->
        <svg class="amg-car" viewBox="0 0 260 132" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M66 62 V48 Q66 44 70 44 H104 L110 34 H116
                   V21 Q116 18 119 18 H129 Q132 18 132 21 V38
                   H144 V17 Q144 14 147 14 H161 Q164 14 164 17 V38
                   H174 Q188 38 188 50 V54 Q188 62 178 62 Z"/>
          <path d="M82 44 V62"/>
          <g stroke-width="1.3"><path d="M70 49 H78 M70 53 H78 M70 57 H78"/></g>
          <path d="M112 35 L104 22"/>
          <ellipse cx="103" cy="21" rx="8" ry="2.8"/>
          <circle cx="110" cy="46" r="4.6"/>
          <circle cx="92" cy="88" r="26"/><circle cx="92" cy="88" r="4.4"/>
          <circle cx="166" cy="88" r="26"/><circle cx="166" cy="88" r="4.4"/>
          <g stroke-width="1.2">
            <path d="M92 62 V114 M66 88 H118 M73.6 69.6 L110.4 106.4 M73.6 106.4 L110.4 69.6"/>
            <path d="M166 62 V114 M140 88 H192 M147.6 69.6 L184.4 106.4 M147.6 106.4 L184.4 69.6"/>
          </g>
        </svg>
        <p class="amg-t">Photograph still being sought</p>
        <button class="amg-c" type="button" (click)="onContribute()">Contribute a photograph</button>
        <p class="amg-why" *ngIf="selected.gapNote">{{selected.gapNote}}</p>
      </div>

      <!-- never issued -->
      <div class="am-never" *ngIf="selected.state === 'never'">
        <span class="plate-bs"><span class="ch">{{selected.letter}}</span></span>
        <p>Never issued as a single-letter mark</p>
      </div>
    </div>
  </div>
</div>
